import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Field from '../../../../../../../components/Form/Field'

import { formatCurrency, formatNumber } from '../../../../../../../helpers/numbers'

import { campaignSelector } from '../../../../../../../modules/selectors/campaigns'
import { selectedTikTokAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { CAMPAIGN_BUDGET } from '../../../../../../Multiplatform/CampaignForms/fields'
import { BUDGET_MODE_TOTAL, BUYING_TYPE } from '../../../../../../Tiktok/fields'
import { BUDGET } from '../../../../../../Tiktok/LineItemForms/LineItemTikTokEdit/fields'

const BudgetContent = ({ formik, budgetType, remainingBudget }) => {
  const { t } = useTranslation()

  const campaign = useSelector(campaignSelector)
  const { currency_symbol: currencySymbol } = useSelector(selectedTikTokAdAccountSelector)

  const { [BUDGET]: budget } = campaign

  if (budgetType === CAMPAIGN_BUDGET) {
    const formattedCampaignBudget = formatCurrency(budget, { min: 2, max: 2 }, { symbol: currencySymbol })

    const budgetTypeMessage = campaign[BUYING_TYPE] === BUDGET_MODE_TOTAL ? 'lifetime' : 'daily'

    return (
      <>
        <p>{`${t(`There is a campaign ${budgetTypeMessage} budget of`)} ${formattedCampaignBudget}. ${t(
          'This will be allocated across ad groups based on performance.'
        )}`}</p>
        <p>{t('If you want to edit this budget, edit the campaign.')}</p>
      </>
    )
  }

  if (budgetType) {
    return (
      <>
        {remainingBudget && (
          <p>{t(`Your remaining budget is ${currencySymbol}` + formatNumber(remainingBudget, { max: 2 }))}</p>
        )}
        <Field
          type="number"
          formik={formik}
          name={BUDGET}
          placeholder={t('Lifetime Budget')}
          symbol={currencySymbol}
          autoComplete="off"
        />
      </>
    )
  }

  return null
}

BudgetContent.propTypes = {
  formik: PropTypes.object.isRequired,
  budgetType: PropTypes.string.isRequired
}

export default BudgetContent
